<template>
  <div>
    <v-layout row wrap pa-2>
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs12 v-for="p in products" :key="p.key" mb-1>
            <v-card>
              <v-layout row wrap>
                <v-flex xs3 pa-1>
                  {{p.item_name}}
                </v-flex>
								<v-flex xs3 pa-1 v-if="p.warehouse">
                  <v-layout row wrap>
										<v-flex xs12 v-for="(w, k) in p.warehouse" :key="p.key+k">
											{{w.country.code}} : <span :class="`${(parseInt(w.quantity) < 3) ? 'white--text error' : null}`"> {{w.quantity}} | Price: {{w.clearance_price_object ? w.clearance_price_object.price : 0}}</span>
										</v-flex>
									</v-layout>
                </v-flex>
								<v-flex xs3 pa-1 v-if="p.warehouse">
                  <v-layout row wrap>
										<v-flex xs12 v-for="(w, k) in p.warehouse" :key="p.key+k">
											{{w.country.code}} : <span :class="`${(parseInt(w.priority) < 3) ? 'white--text success' : null}`">Priority: {{w.priority ? w.priority : 9999}}</span>
										</v-flex>
									</v-layout>
                </v-flex>
              </v-layout>
            </v-card>
            <v-expansion-panel expand>
              <v-expansion-panel-content>
                <div slot="header">Details</div>
                <v-card>
                  <v-card-text>
                    <v-layout row wrap ma-2>
                      <v-flex xs12>
                        <v-card>
                  {{p.warehouse}}
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import {firebase, db, auth, storageRef } from '@/fb';
import { getRandomInt, randomString, getCDate, check, uuid } from '@/customFunction';
import axios from 'axios';

export default {
  data() {
    return {
			config: {
        fontsize_formats: "8px 10px 12px 14px 16px 18px 20px 22px 24px 26px 39px 34px 38px 42px 48px",
        plugins: 'print preview fullpage powerpaste searchreplace autolink',
        toolbar1: 'formatselect fontsizeselect | bold italic strikethrough forecolor backcolor link',
      },
			loading:false,
			products:[],
			dialog:false,
			dialogAdd:false,
			selectedProduct:null,
			nKey:null,
			nPrice:null,
			nName:null,
			nSKU:null,
			dialogDelete:false,
			name:null,
			fileName:null,
			uploadURL:null,
			imgURLExt:null,
			uploadProgress:null,
			warehouses:[],
			addWarehouseD:false,
			warehouseName:null,
			warehouseCountry:null,
			countries:[],
			clearancePrices:[],
		}
	},
	methods:{
		async addWarehouseToDB(){
			if(!this.warehouseName || !this.warehouseCountry) return true
			await db.ref(`settings/warehouses`).push({
				name:this.warehouseName,
				country:this.warehouseCountry
			})
			this.addWarehouseD = false
			this.getLoadData()
		},
		async getLoadData(){
			let w =	await db.ref(`settings/warehouses`).once('value').then(x=>x.val())
			for (const key in w) {
				if (w.hasOwnProperty(key)) {
					const warehouse = w[key];
					warehouse.key = key
					this.warehouses.push({
						text:warehouse.name,
						key:key,
						country:warehouse.country
					})
				}
			}
			let c = await db.ref(`countries`).once('value').then(x=>x.val())
			for (const key in c) {
				if (c.hasOwnProperty(key)) {
					const country = c[key];
					if(country.alpha2Code)
					this.countries.push({
						text:country.name,
						code:country.alpha2Code
					})
				}
			}
		},
		async saveWareHousesToProduct(){
			if (this.selectedProduct.warehouse) {
				console.log(this.selectedProduct.warehouse)
				for (let i = 0; i < this.selectedProduct.warehouse.length; i++) {
					const w = this.selectedProduct.warehouse[i];
					w.quantity = parseInt(w.quantity)
				}
				await db.ref(`products/${this.selectedProduct.key}/warehouse`).set(this.selectedProduct.warehouse)
				this.$emit('snackbarNotification', `${this.selectedProduct.item_name} warehouses updated`, 'success')
				let c = this.selectedProduct.warehouse.filter(x=>x.clearance == true)
				if(c && c.length> 0){
					await db.ref(`products/${this.selectedProduct.key}`).update({
						clearance:true
					})
				} else {
					await db.ref(`products/${this.selectedProduct.key}`).update({
						clearance:false
					})
				}
			}
		},
		isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
		},
		removeWearhouse(k){
			this.selectedProduct.warehouse.splice(k, 1)
		},
		addWarehouse(key){
			console.log('a')
			this.selectedProduct.warehouse.push({
				country:'',
				warehouse:'',
				quantity:0,
				clearance_price:0,
				clearance:false,
			})
		},
		async getProducts(){
      await db.ref(`products`)
      .orderByChild('clearance').equalTo(true)
			.once('value').then( x => {
				let products = x.val()
				let productsArr = []
				for (const key in products) {
					if (products.hasOwnProperty(key)) {
						const product = products[key];
						product.key = key
						product.text = product.item_name
						if(!product.warehouse) product.warehouse = []
						productsArr.push(product)
					}
				}
				return this.products = productsArr
			})
		},
		updateKey(key, val) {
			console.log(this.selectedProduct.key)
			console.log(key)
			console.log(val)
			if(!val || !key || !this.selectedProduct || !this.selectedProduct.key) return
			db.ref(`products/${this.selectedProduct.key}`)
			.update({
				[key]:val
			})
			.then(x=>{
        this.$emit('snackbarNotification', `${key.toUpperCase()} is updated to ${val}`, 'success')
			})
		},
		addPrice(){
			let key = this.nKey.replace(/[\/\.\*\\#$\[\]\t\n\r\s]/g, '_')
			let p = this.nPrice
			db.ref(`products/${this.selectedProduct.key}`)
			.update({
				[key]:p
			})
			.then(x=>{
				this.$emit('snackbarNotification', `${key.toUpperCase()} is added and set to ${val}`, 'success')
				this.nKey = null
				this.nPrice = null
			})
		},
		removePrice(key) {
			
			db.ref(`products/${this.selectedProduct.key}`)
			.update({
				[key]:null
			})
			.then(x=>{
				this.selectedProduct[key] = null
        this.$emit('snackbarNotification', `${key.toUpperCase()} is removed`, 'success')
			})
		},
		async addProduct(){
			let product = {
				item_name:this.nName,
				sku:this.nSKU,
				[this.nKey.replace(/[\/\.\*\\#$\[\]\t\n\r\s]/g, '_')]: parseFloat(this.nPrice)
			}
			let x = await db.ref(`products`)
			.push(product);
			product.key = x.key;
			product.text = product.item_name;
			this.products.push(product);
			this.dialogAdd = false
			this.selectedProduct = product;
			this.$emit('snackbarNotification', `${product.item_name} is added`, 'success')

		},
		async deleteProduct(){
			let oKey = this.selectedProduct.key
			db.ref(`products`)
			.update({
				[this.selectedProduct.key]:null
			})
			.then(x=>{
				this.$emit('snackbarNotification', `${this.selectedProduct.item_name} is deleted`, 'success')
				let index = this.products.findIndex(x=> x.key == oKey)
				this.products.splice(index, 1)
				this.selectedProduct = null
				this.dialogDelete = false
			})
		},
		addImage(){
      console.log('s')
      this.pickFile()
    },
    pickFile() {
      this.$refs.file.click()
    },
    loadFile(file, type, ext){
      var file = file
      var metadata = {
        contentType: type
      };
      var uploadTask = storageRef.child('images/ashyaat' + randomString(8, 'Aa#') + '.' + ext).put(file, metadata);
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        (snapshot)=> {
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
					this.uploadProgress = true
					this.selectedProduct.img = progress
                }, (error) =>{
          console.log(error);

        switch (error.code) {

          case 'storage/unauthorized':
            break;
          case 'storage/canceled':
            break;
          case 'storage/unknown':
            break;
        }
      },() => {
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) =>{
          console.log('File available at', downloadURL);
          this.uploadURL = downloadURL
          this.imgURL = downloadURL
					this.loading = false
					this.uploadProgress = false
					console.log(this.selectedProduct)
					this.selectedProduct.img = downloadURL
        });
      });
    },
    onFilePicked (e) {
      this.loading = true
      const files = e.target.files
      if(files[0] !== undefined) {
        const fr = new FileReader ()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.file = files[0] // this is an image file that can be sent to server...
          console.log(this.file)
          this.imgURLExt = `.${this.file.name.split('.').pop()}`
          this.loadFile(this.file, this.file.type, this.file.name.split('.').pop())
        })
      } else {
        this.name = null
        this.fileName = null
        this.uploadURL = null
      }
    },
	},
	props: {
    userName: {
      required: true,
      default: null
    },
    userImage: {
      required: true,
      default: ''
    },
    userRole: {
      required: true,
      default: 'user'
    },
    beta: {
      required: true,
      default: false
    },
    superAdmin: {
      required: true,
      default: false
    },
	},
	watch:{
		selectedProduct(){
			let noK = ['import_date', 'item_name', 'sku', 'key', 'text', 'warehouse', 'clearance', 'img', 'description_ar', 'description_en', 'name_ar', 'name_en', 'clearance_name_ar', 'clearance_name_en', 'import_date', 'key', 'text']
			for (const key in this.selectedProduct) {
				if (this.selectedProduct.hasOwnProperty(key) && noK.indexOf(key) == -1) {
					const p = this.selectedProduct[key];
					if(p && p !=0 && p != '0' && p!= ''){
						this.clearancePrices.push({
							text:key.split('_').join(' '),
							name:key,
							price:p
						})
					}
				}
			}
		}
	},
	async created(){
		this.getProducts()
		this.getLoadData()
		
		let products = await db.ref(`products`).orderByChild('clearance').equalTo(true).once('value').then(x=>x.val())
		let productsArr = []
		for (const key in products) {
			if (products.hasOwnProperty(key)) {
				const product = products[key];
				productsArr.push({
					key,
					name:product.item_name,
					warehouse:product.warehouse,
					name_ar:product.name_ar,
					description_ar:product.description_ar,
					name_en:product.name_en,
					description_en:product.description_en,
					img:product.img,
					clearance_name_ar:product.clearance_name_ar,
					clearance_name_en:product.clearance_name_en,
					sku:product.sku
				})
			}
		}
		console.log(productsArr)
	}
}
</script>

<style>

</style>
